/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import * as types from '../actions/ActionTypes';

const initialState = {};

export default function location(state = initialState, action) {
  if (action.type == types.LOCATION_CHANGE) {
    return action.payload;
  } else {
    return state;
  }
}
